/**
 * @generated SignedSource<<f513e8fb6664292f61d45a478c20a8ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useDisputesRelayByIdQuery$variables = {
  id: string;
};
export type useDisputesRelayByIdQuery$data = {
  readonly getDispute: {
    readonly amount: number;
    readonly charge: {
      readonly amount: number | null | undefined;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly paymentIntentId: string | null | undefined;
      readonly status: string | null | undefined;
    } | null | undefined;
    readonly chargeId: string;
    readonly createdOn: any | null | undefined;
    readonly evidenceDueBy: string | null | undefined;
    readonly fee: number | null | undefined;
    readonly id: string;
    readonly isOpen: boolean | null | undefined;
    readonly net: number | null | undefined;
    readonly organizationId: string | null | undefined;
    readonly reason: string | null | undefined;
    readonly status: string;
    readonly stripeDisputeId: string;
    readonly system: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly systemId: string | null | undefined;
    readonly user: {
      readonly email: string | null | undefined;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
      readonly phone: string;
    } | null | undefined;
  } | null | undefined;
};
export type useDisputesRelayByIdQuery = {
  response: useDisputesRelayByIdQuery$data;
  variables: useDisputesRelayByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Dispute",
    "kind": "LinkedField",
    "name": "getDispute",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fee",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "net",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "chargeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stripeDisputeId",
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isOpen",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "evidenceDueBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdOn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Charge",
        "kind": "LinkedField",
        "name": "charge",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentIntentId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "System",
        "kind": "LinkedField",
        "name": "system",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDisputesRelayByIdQuery",
    "selections": (v4/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDisputesRelayByIdQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "034e296d3cba6f05c57bba85ac3d8ceb",
    "id": null,
    "metadata": {},
    "name": "useDisputesRelayByIdQuery",
    "operationKind": "query",
    "text": "query useDisputesRelayByIdQuery(\n  $id: ID!\n) {\n  getDispute(id: $id) {\n    id\n    amount\n    fee\n    net\n    chargeId\n    stripeDisputeId\n    status\n    reason\n    isOpen\n    evidenceDueBy\n    createdOn\n    systemId\n    organizationId\n    charge {\n      id\n      amount\n      status\n      description\n      paymentIntentId\n    }\n    user {\n      id\n      firstName\n      lastName\n      email\n      phone\n    }\n    system {\n      id\n      oldId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16da65a62a95a69acfe5df422c0ed70d";

export default node;
